import { createContext, JSX, PropsWithChildren } from 'react';
import { UseManageTableReturnType } from './hooks';

export type ManageTablePropsType = PropsWithChildren<UseManageTableReturnType>;

export const ManageTableContext =
  createContext<UseManageTableReturnType | null>(null);

export const ManageTableProvider = ({
  children,
  ...manageTableProps
}: ManageTablePropsType): JSX.Element => {
  return (
    <ManageTableContext.Provider value={manageTableProps}>
      {children}
    </ManageTableContext.Provider>
  );
};
